export default {
  EsoCommonReducer: {
    statusInfo: [],
    systemPaxFigure: {},
    soCustomization: {},
  },
  dashboardFilterCriteria: {},
  AcSeatCfgModalReducer: { modal: false },
  PaxSearchRuleReducer: null,
  PollingPoliciesReducer: null,
  serviceOrderQueryCriteriaParams: null,
  TopFocusItemsReducer: null,
  SmartOrderDashboardReducer: null,
  ImportOrderSearchReducer: null,
};
